import { getInstance } from "./auth";
import { NavigationGuard } from "vue-router";

export const authenticationGuard: NavigationGuard = (to, from, next) => {
  const authService = getInstance();

  // If Auth0 added `code` and `state`, clean them while keeping other query parameters
  if (to.query.code || to.query.state) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { code, state, ...originalQuery } = to.query; // Keep everything except `code` and `state`

    next({ path: to.path, query: originalQuery, replace: true });
    return;
  }

  const fn = () => {
    // Unwatch loading
    if (unwatch) {
      unwatch();
    }

    // If the user is authenticated, continue with the route
    if (authService.isAuthenticated) {
      return next();
    }

    // Otherwise, redirect to Auth0 login and store the full path (including query parameters)
    authService.loginWithRedirect({
      appState: { targetUrl: to.fullPath },
    });
  };

  // Watch for the loading property to change before checking isAuthenticated
  const unwatch = authService.$watch("loading", (loading: boolean) => {
    if (loading === false) {
      fn();
    }
  });

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn();
  }
};
